import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from 'react'
import { ArrowUpRight } from 'lucide-react'
import { cx } from '@shared/lib/cx'
import { navigationLink, navigationLinkIcon, navigationLinkLabel } from './NavigationLink.css'

type NavigationLinkProps =
  | (AnchorHTMLAttributes<HTMLAnchorElement> & { href: string })
  | (ButtonHTMLAttributes<HTMLButtonElement> & { href?: never })

/** Contextual navigation: keep a real anchor for URLs and a button for opening a related drawer. */
export function NavigationLink(props: NavigationLinkProps) {
  const content = (children: ReactNode) => (
    <>
      <span className={navigationLinkLabel}>{children}</span>
      <ArrowUpRight className={navigationLinkIcon} size={14} aria-hidden="true" />
    </>
  )

  if (props.href !== undefined) {
    const { children, className, ...rest } = props
    return (
      <a {...rest} className={cx(navigationLink, className)}>
        {content(children)}
      </a>
    )
  }

  const { children, className, type = 'button', ...rest } = props
  return (
    <button {...rest} type={type} className={cx(navigationLink, className)}>
      {content(children)}
    </button>
  )
}
